<template>
  <a-modal title="运行流水线" :visible="visible" @cancel="onClose">
    <template slot="footer">
      <a-button @click="onClose"> 取消 </a-button>
      <a-button v-tc="{ name: '调试' }" :loading="loading" @click="onSubmit('debug')"> 调试 </a-button>
      <a-button v-tc="{ name: '确认构建' }" type="primary" :loading="loading" @click="onSubmit('build')">确认构建</a-button>
    </template>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="构建分支" prop="branch">
        <a-select v-model="form.branch" placeholder="请选择构建分支" :filter-option="false" :show-search="true" @search="getBranchList">
          <a-select-option v-for="(branch, index) in branchList" :key="index" :value="branch.name"> {{ branch.name }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="name" label="备注" prop="name">
        <a-textarea v-model="form.description" :rows="2" placeholder="请输入备注信息" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { gitlabBranchList } from '@/api/system/service';
import { pipelineBuild } from '@/api/project/pipeline';

export default {
  data() {
    return {
      loading: false,
      visible: false,
      form: {},
      branchList: [],
      search: null,
      rules: {
        branch: [{ required: true, message: '构建分支不能为空', trigger: 'blur' }]
      },
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  methods: {
    onClose() {
      this.utils.trackClick({ name: '取消构建' });
      this.visible = false;
      this.loading = false;
      this.$refs.form.resetFields();
    },

    onOpen(record) {
      this.visible = true;
      this.form = {
        branch: record.branch,
        pipeline_id: record.pipeline_id
      };
      this.gitId = record.git_id;
      this.getBranchList();
    },

    getBranchList(value = null) {
      gitlabBranchList({ git_id: this.gitId, search: value }).then(response => {
        this.branchList = response.data.branch_list;
      });
    },

    onSubmit(event) {
      this.utils.trackClick({ name: '确认构建' });
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          pipelineBuild({ ...this.form, project_id: this.projectId })
            .then(res => {
              this.loading = false;
              this.visible = false;
              this.$message.success('构建任务创建成功');
              this.$emit('close');
              if (event === 'debug') {
                // 跳转至构建详情页
                const record_route = {
                  name: 'page:project:cicd:pipeline:detail',
                  query: { recordId: res.data.record_id }
                };
                if (this.$route.name === 'page:project:cicd:pipeline:detail') {
                  this.$router.replace(record_route).catch(() => {});
                  this.$router.go(0);
                } else {
                  window.open(this.$router.resolve(record_route).href);
                }
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
